import React, { useState } from 'react';

const PageZoom = () => {
    const [zoom, setZoom] = useState(1);

    const handleZoom = (factor: number) => {
        const newZoom = Math.min(Math.max(zoom + factor, 0.5), 2);
        setZoom(newZoom);
        document.body.style.setProperty('zoom', `${newZoom}`);
    };

    return (
        <div
            style={{
                display: 'flex',
                gap: '12px',
                backgroundColor: '#f9f9f9',
                border: '1px solid #ddd',
                borderRadius: '12px',
                padding: '10px 14px',
                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
                zIndex: 1000,
                fontFamily: 'sans-serif',
            }}
        >
            <button
                style={{
                    padding: '6px 10px',
                    fontSize: '0.9rem',
                    borderRadius: '6px',
                    border: '1px solid #ccc',
                    background: 'rgb(18, 0, 255)',
                    cursor: 'pointer',
                    transition: 'background 0.2s',
                    color: 'white',
                    fontWeight: 'bold',
                }}
                onClick={() => handleZoom(0.1)}
            >
                A+
            </button>
            <button
                style={{
                    padding: '6px 10px',
                    fontSize: '0.9rem',
                    borderRadius: '6px',
                    border: '1px solid #ccc',
                    background: 'rgb(18, 0, 255)',
                    cursor: 'pointer',
                    transition: 'background 0.2s',
                    color: 'white',
                    fontWeight: 'bold',
                }}
                onClick={() => handleZoom(-0.1)}
            >
                A-
            </button>
        </div>
    );
};

export default PageZoom;
